export default "__VITE_ASSET__M3JAu6fD__"